//export const YGL_KEY = "0BRKyETU5DxcMf4WutQZHlmbJX7e92nao3IOrdFA"
export const GOOGLE_KEY = "AIzaSyB1nxNOS3_g7WYasrTBbHpS9CMNhavd7wQ"
export const GOOGLE_HOME_PLACEID = "ChIJAQBE68N544kRl-xBRXADKHM"
export const GOOGLE_HOME_MAPSTRING = "Upright+Realty+Commonwealth+Boston"
export const GOOGLE_MAPS_URL = "https://www.google.com/maps/embed/v1/place?key=" + GOOGLE_KEY
export const UPRIGHT_API_BASE_URL = process.env.VUE_APP_UPRIGHT_API_BASE
export const LISTINGS_URL = UPRIGHT_API_BASE_URL + "rentals"
export const AGENTS_URL = UPRIGHT_API_BASE_URL + "agents"
export const FEATURED_URL = UPRIGHT_API_BASE_URL + "rentals/featured"
export const AUTHORIZED_BASE = UPRIGHT_API_BASE_URL + "authorized/"
export const FEATURED_IDS_URL = AUTHORIZED_BASE + "featured"
export const NEIGHBORHOODS_URL = UPRIGHT_API_BASE_URL + "accounts/neighborhoods"
export const LEADS_ADD_URL = UPRIGHT_API_BASE_URL + "leads/lead-add"
export const AUTHENTICATE_URL = AUTHORIZED_BASE + "authenticate"